import { render, staticRenderFns } from "./VnoOpenPay.vue?vue&type=template&id=c28f25e8&scoped=true&"
import script from "./VnoOpenPay.vue?vue&type=script&lang=js&"
export * from "./VnoOpenPay.vue?vue&type=script&lang=js&"
import style0 from "./VnoOpenPay.vue?vue&type=style&index=0&id=c28f25e8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c28f25e8",
  null
  
)

export default component.exports